<div fxLayout="column" fxLayoutAlign="start center center" style="height:100vh; background-color: white;">
    <div fxLayout="column" fxLayoutAlign="center center center">
        <img src="assets/images/success.png" alt="success" style="width: 150px; height: 150px;">
    Η υποβολή της δήλωσής σας ολοκληρώθηκε με επιτυχία
    </div>
</div>
